import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { HomeSiteProvider } from '@/features/home/context/HomeSiteProvider'
import { ToastHost } from '@/shared/components/toast/ToastHost'
import { router } from './routes'
import './i18n'
import './styles/globals.css'
import './styles/home-studio.css'
import './styles/site-portal-nav.css'

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('找不到 #root 节点')
}

createRoot(rootEl).render(
  <StrictMode>
    <HomeSiteProvider>
      <RouterProvider router={router} />
      <ToastHost />
    </HomeSiteProvider>
  </StrictMode>,
)
